// Filename: src/screens/books/Books.jsx
// Last Updated: 2025-02-03 19:09:19 UTC
// Author: raghavkunkee

import { useState } from 'react';
import BookMainFile from './BookMainFile';

/**
 * Books component serves as the container for book-related functionality
 * @returns {JSX.Element} Rendered component
 */
const Books = () => {
  const [allowBookMain, setAllowBookMain] = useState(true);
  const [productDetail, setProductDetail] = useState({});
  const [tableData, setTableData] = useState([]);
  const [searchKey, setSearchKey] = useState('');

  return (
    <BookMainFile
      setAllowBookMain={setAllowBookMain}
      setProductDetail={setProductDetail}
      productDetail={productDetail}
      setTableData={setTableData}
      tableData={tableData}
      allowBookMain={allowBookMain}
      searchKey={searchKey}
      setSearchKey={setSearchKey}
    />
  );
};

export default Books;